import { Component, Prop, h, State, Element, Host } from '@stencil/core';
import { SiteSelectori18n } from './pn-site-selector-types';
import languageData from './pn-site-selector-i18n';
import { angle_small_down } from 'pn-design-assets/pn-assets/icons.js';
@Component({
  tag: 'pn-site-selector',
  styleUrl: 'pn-site-selector.scss',
})
export class PnSiteSelector {
  @Element() hostElement: HTMLElement;

  /* Site selector Button text */
  @Prop({ mutable: true, reflect: true }) buttontext: string = 'postnord';
  /* Site selector flyout title */
  @Prop({ mutable: true, reflect: true }) heading: string = 'PostNord';
  /** Specifies which language we want to show navigation in (sv,da,fi,no,en) */
  @Prop({ mutable: true, reflect: true }) language: string = 'sv';
  @State() i18n: SiteSelectori18n = { navlabel: 'Site selector' };

  componentWillLoad() {
    this.setLanguage();
  }

  setLanguage() {
    if (languageData[this.language]) {
      this.i18n = languageData[this.language] as SiteSelectori18n;
    }
  }

  render() {
    return (
      <Host>
        <pn-button-dropdown label={this.buttontext} icon={angle_small_down} appearance="light" variant="borderless">
          <div class="siteselector-nav" aria-label={this.i18n.navlabel}>
            {this.heading ? <strong class="siteselector-heading">{this.heading}</strong> : null}
            <div role="menu" class="siteselector-list">
              <slot />
            </div>
          </div>
        </pn-button-dropdown>
      </Host>
    );
  }
}
